"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formik = require("formik");
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var MessageError = function MessageError(_ref) {
  var control = _ref.control,
    component = _ref.component,
    messageError = _ref.messageError,
    noShow = _ref.noShow,
    $bsStyle = _ref.$bsStyle;
  if (messageError) {
    return /*#__PURE__*/_react.default.createElement(_styled.WrapperMessage, {
      $bsStyle: $bsStyle
    }, messageError);
  }
  if (!control || noShow) {
    return /*#__PURE__*/_react.default.createElement(_styled.EmptyDiv, {
      $bsStyle: $bsStyle
    });
  }
  return /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: control,
    component: component,
    render: function render(msg) {
      return /*#__PURE__*/_react.default.createElement(_styled.Error, {
        $bsStyle: $bsStyle
      }, msg);
    }
  });
};
MessageError.propTypes = {
  control: _propTypes.default.string,
  component: _propTypes.default.string,
  messageError: _propTypes.default.string,
  noShow: _propTypes.default.bool,
  $bsStyle: _propTypes.default.shape({})
};
MessageError.defaultProps = {
  control: null,
  component: 'div',
  messageError: null,
  noShow: false,
  $bsStyle: {}
};
var _default = MessageError;
exports.default = _default;